import { Component } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Observable, Subject } from "rxjs";

import { BfxDialogData } from "./models/bfx-dialog-data.model";

import { BfxDialogBaseComponent } from "./bfx-dialog-base.component";

import { TableDefinition } from "shared/cubiq-services";
import { GoldenLayoutService } from "../golden-layout/golden-layout-service";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

import { NativeDesktopSupport } from "../bfx-native-desktop/native-desktop-support";

@Component({
  selector: `bfx-dialog-reconnect`,
  templateUrl: `./html/bfx-dialog-reconnect.html`,
  standalone: false,
})
export class BfxDialogReconnectComponent extends BfxDialogBaseComponent {
  public title: string = "";
  public messages: Array<string> = [];
  public tableDefinition: TableDefinition = null;
  public subMessage: string = null;
  public yesLabel: string;
  public noLabel: string;

  public reconnect: boolean = false;
  private autoReconnectionTimeoutId;

  public data: any = {
    dialogId: null,
    dialogEventSubject: new Subject<BfxDialogData>(),
    actionEvent: null,
    payload: null,
    dialogData: {
      show: false,
      width: 450,
      count: 0,
    },
  };

  constructor(
    protected layoutService: GoldenLayoutService,
    protected translationService: TranslateService,
  ) {
    super();

    this.yesLabel = this.translationService.instant("reconnect.dialog.button.yes.label");

    this.noLabel = this.translationService.instant("reconnect.dialog.button.no.label");
  }

  public openDialog(_dialogData: BfxDialogData): Observable<any> {
    try {
      this.data.dialogId = _dialogData.dialogId;
      this.data.actionEvent = _dialogData.event;
      this.data.payload = _dialogData.payload;

      if (_dialogData.payload != null) {
        this.messages = _dialogData.payload.messages;
        this.title = _dialogData.payload.title;
        this.subMessage = _dialogData.payload.subMessage;

        if (_dialogData.payload.autoReconnectionTimeout >= 0) {
          this.autoReconnectionTimeoutId = setTimeout(() => {
            this.data.payload.callback(this.data.actionEvent);
          }, _dialogData.payload.autoReconnectionTimeout);
        }
      }

      if (this.messages.length > 0) {
        this.title = this.translationService.instant(this.title);
        this.data.dialogData.show = true;
      }
    } catch (ex) {
      logger.out.error(
        "ERROR: BfxDialogReconnectComponent.openDialog(): Dialog exception! msg:",
        ex,
      );
    }

    return this.data.dialogEventSubject.asObservable();
  }

  public closeDialog(): void {
    if (this.data.payload.callbackNegative && !this.reconnect) {
      this.data.payload.callbackNegative(this.data.actionEvent);
    }

    clearTimeout(this.autoReconnectionTimeoutId);

    this.data.dialogData.title_text = null;
    this.data.dialogData.message_text = null;
    this.data.dialogData.message_text_ids = null;
    this.data.actionEvent = null;
    this.data.payload = null;
    this.data.dialogData.show = false;

    // inform dialog service that dialog is closed and to cleanup
    this.notifyDialogClosed(this.data.dialogEventSubject, this.data.dialogId);
    super.closeDialog();
  }

  public actionReconnect(): void {
    clearTimeout(this.autoReconnectionTimeoutId);
    this.reconnect = true;
    this.data.payload.callback(this.data.actionEvent);
    this.closeDialog();
    if (this.reconnect && NativeDesktopSupport.isNativeDesktopContainer()) {
      NativeDesktopSupport.closeAllWindows();
    }
  }

  /**
   * force reconnection dialog to main window body
   */
  public postOpenDialog(dialogData: BfxDialogData): void {
    if (NativeDesktopSupport.isNativeDesktopContainer()) {
      dialogData.body = window.document.body;
    }

    NativeDesktopSupport.prepareEmbeddedDialog(dialogData.body, this._dialog, this._dialog.el);
  }
}
